import React, {useState, useCallback, useEffect, useRef} from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { useDidMount } from "../../coraWebComponents/utils/hooks";

import "./VytvoritVyjadrenie.scss";

// actions
import * as vyjadrenieActions from "../../actions/vyjadrenieActions";
import * as vysledokVyjadreniaActions from "../../actions/ciselniky/zpCVysledokVyjadreniaActions";
// coraWebComponents
import Stepper from "../../coraWebComponents/Stepper";
// stepper items
import Uvod from "./Uvod";
import Ziadost from "./Ziadost";
import Dokumenty from "./Dokumenty";
import Vyjadrenie from "./Vyjadrenie";
import Rekapitulacia from "./Rekapitulacia";

import _ from "lodash";

const VytvoritVyjadrenie = (props) => {
  const navigate = useNavigate();
  const location = useLocation();  
  let childRefs = [];

  const [isMobileView, setIsMobileView] = useState(false);
  const [stepperValue, setStepperValue] = useState(0);
  const [stepperItems, setStepperItems] = useState([
      {
        label: "Úvod",
        render: <Uvod />,
      },
      {
        label: "Žiadosť",
        render: <Ziadost />,
        disabled: true,
      },
      {
        label: "Prílohy a komentáre",
        render: <Dokumenty />,
        disabled: true,
      },
      {
        label: "Vyjadrenie",
        render: <Vyjadrenie />,
        disabled: true,
      },
      {
        label: "Rekapitulácia",
        icon: "k-i-track-changes-accept",
        render: <Rekapitulacia />,
        disabled: true,
      },
    ]);

  // GET visible form
  const getFormElement = () => {
    const webFormEl = document.getElementById(`webForm${stepperValue}`);
    const mobileFormEl = document.getElementById(`mobileForm${stepperValue}`);

    return webFormEl || mobileFormEl;
  };
  // HANDLE on change stepper
  const handleOnChange = async (value) => {
    const form = getFormElement();

    const isValidForm = form?.reportValidity();
    if (!form || isValidForm) {
      const childRef = childRefs[stepperValue];
      if (childRef?.saveData) await childRef.saveData();

      moveToAnotherStepperItem(value);
    }
  };

  // REMOVE/ADD isValid prop -> user going back=>remove, forward=>add
  const handleItemsProps = (nextValue) => {
    const currValue = stepperValue;
    let items = _.cloneDeep(stepperItems);

    items = items.map((item, i) => {
      delete item.isValid;

      if (i < nextValue) item["isValid"] = true;
      if (i === currValue) item.disabled = false;

      return item;
    });

    return items;
  };
  // MOVE to next/previous stepper item
  const moveToAnotherStepperItem = (value) => {
    const items = handleItemsProps(value);
    setStepperItems([...items]);
    setStepperValue(value);    
  };
  // HANDLE next(submit) button
  const handleOnClickNext = (e = null) => {
    if (e) e.preventDefault();
    handleOnChange(stepperValue + 1);
  };
  // HANDLE back button
  const handleOnClickBack = () => {
    handleOnChange(stepperValue - 1);
  };
  // HANDLE cancel button
  const handleOnClickCancel = () => {
    navigate(location.state.from, { state: { skipBlocker: true } });
  };
  // HANDLE on enter pressed in form
  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };
  // SAVE refs of childs
  const setRef = (childRef, i) => {
    childRefs[i] = childRef;
  };


  useDidMount(async() => {
    const {
      changeVyjadrenie,
      changeVysledokVyjadrenia,      
    } = props;

    await changeVyjadrenie(null);
    await changeVysledokVyjadrenia(null);      
  })
  
  return (
      <>
        <Stepper
          name="stepperValue"
          items={stepperItems}
          value={stepperValue}
          handleChange={handleOnChange}
        />
        {stepperItems.map((item, i) => {
          const className = i === stepperValue ? "vyjadrenieScrollItem" : "displayNone";
          const elProps = {
            setRef: (ref) => setRef(ref, i),
            moveNext: handleOnClickNext,
            moveBack: handleOnClickBack,
            cancel: handleOnClickCancel,
            onKeyDown: handleOnKeyDown,
            className,
            index: i,
            key: i,
          };
          return React.cloneElement(item.render, elProps);
        })}
      </>
    ); 
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  changeVyjadrenie: (vyjadrenie) => dispatch(vyjadrenieActions.changeVyjadrenie(vyjadrenie)),
  changeVysledokVyjadrenia: (vysledokVyjadrenia) => dispatch(vysledokVyjadreniaActions.changeVysledokVyjadrenia(vysledokVyjadrenia)),
});

VytvoritVyjadrenie.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(VytvoritVyjadrenie);
